import { render, staticRenderFns } from "./TeLlamamosConfirmTel.vue?vue&type=template&id=6e7f244c&scoped=true&"
import script from "./TeLlamamosConfirmTel.vue?vue&type=script&lang=js&"
export * from "./TeLlamamosConfirmTel.vue?vue&type=script&lang=js&"
import style0 from "./TeLlamamosConfirmTel.vue?vue&type=style&index=0&id=6e7f244c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f244c",
  null
  
)

export default component.exports